import React, { Component } from 'react';
import { setTrackSteps, executeTaggeo } from '../../store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import { Link } from "react-router-dom";
import HeaderPaymentFormClaroSocio from '../organisms/HeaderPaymentFormClaroSocio';
import HeaderPaymentForm from '../organisms/HeaderPaymentForm'
import ContPacks from '../organisms/PacksMultiples';
import { logEvent } from 'firebase/analytics';
//import { firebaseAnalytics } from '../../firebaseConfig';

const Container = styled.div`
  width: 100%;
  overflow: scroll;
  background: #f7f8f8;
  > a:last-child {
      > div:first-child {
          margin-bottom: 60px;
      }
    }
`;

const TitleMember = styled.div`
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: #1e1e1e;
    margin-bottom: 8px;
`;

const SubTitleMember = styled.div`
    font-size: 12px;
    text-align: center;
    color: #5f5f5f;
    margin-bottom: 16px;
    opacity: 0.80;
`;

const TitleNotMember = styled.div`
    font-size: 12px;
    font-family: 'Amx-Regular';
    color: rgb(50, 50, 50);
    opacity: 0.95;
    text-align: center;
    &:nth-child(2) { margin-bottom: 10px; }
    &:nth-child(3) { margin-bottom: 25px; }
`;

class MenuTelcelContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            serviceConfig: this.props.paymentsConfig.services[0].serviceData.generic,
            serviceInfo: this.props.paymentsConfig.services[0].serviceData.info,
        }
    }

    componentDidMount() { 
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.trackId !== this.props.trackId) {
            this.setStepTrack('PLTE01', nextProps.trackId);
        }
    }

    setStepTrack = (step, trackId) => {
        this.props.setTrackSteps(
            trackId,
            `${step}`
        );
    }

    sendAnalytics(tagServiceId, step, action) {
        // logEvent(firebaseAnalytics, 'pay_service_or_tae', {
        //     claro_id: `${this.props.payments.userInfo.username}`,
        //     msisdn: `${btoa(this.props.payments.userInfo.msisdn.slice(3, 13))}`,
        //     service: `${tagServiceId}`,
        //     step: `${step}`,
        //     action: `${action}`
        // });
    }

    render() {
        let config = this.props.paymentsConfig;
        return (
            <Container>
                {this.props.isClaroPartner ?
                    <>
                        <HeaderPaymentFormClaroSocio
                            serviceSubtitleLabel={' '}
                        />
                        <TitleMember>{'Paquetes Telcel'}</TitleMember>
                        <SubTitleMember>{'Elige tu favorita'}</SubTitleMember>
                    </>
                :
                    <>
                        <HeaderPaymentForm
                            dataConfigLogo={this.state.serviceConfig.logo.data}
                        />
                        <TitleNotMember>{'¿Qué quieres hacer?'}</TitleNotMember>
                        <TitleNotMember>{'Tenemos estas opciones para ti, elige tu favorita'}</TitleNotMember>
                    </>
                }
                <Link 
                    // onClick={() => {
                    //     this.sendAnalytics(
                    //         this.props.tagServiceId,
                    //         'Principal Telcel',
                    //         'Click Paquetes Amigo sin límite'
                    //     )
                    // }}
                    to={{
                        pathname: '/menuTelcel',
                        state: {
                            sdkVersion: this.props.sdkVersion,
                            paymentsConfig: config, 
                            isClaroPartner: this.props.isClaroPartner,
                            serviceConfigIndex:3,
                            tagServiceId: this.props.tagServiceId,
                            isContainerTelcel: this.props.isContainerTelcel
                        }
                    }}
                >
                    <ContPacks
                        title={"Paquetes Amigo sin límite"}
                        serviceId={config.services[3].serviceData.info.categoryPlansId}
                        hasPromotionMbTelcel = {config.services[3].serviceData.info.hasPromotionMbTelcel}
                        textPromotionMbTelcel = {config.services[3].serviceData.info.textPromotionMbTelcel}
                    />
                </Link>
                <Link 
                    // onClick={() => {
                    //     this.sendAnalytics(
                    //         this.props.tagServiceId,
                    //         'Principal Telcel',
                    //         'Click Recarga de saldo'
                    //     )
                    // }}
                    to={{
                        pathname: '/menuTelcel',
                        state: {
                            sdkVersion: this.props.sdkVersion,
                            paymentsConfig: config, 
                            isClaroPartner: this.props.isClaroPartner,
                            serviceConfigIndex:0,
                            tagServiceId: this.props.tagServiceId
                        }
                    }}
                >
                    <ContPacks
                        title={"Recarga de saldo"}
                        serviceId={config.services[0].serviceData.info.serviceId}
                        hasPromotionMbTelcel = {config.services[0].serviceData.info.hasPromotionMbTelcel}
                        textPromotionMbTelcel = {config.services[0].serviceData.info.textPromotionMbTelcel}
                    />
                </Link>
                <Link 
                    // onClick={() => {
                    //     this.sendAnalytics(
                    //         this.props.tagServiceId,
                    //         'Principal Telcel',
                    //         'Click Paquetes Internet Amigo'
                    //     )
                    // }}
                    to={{
                        pathname: '/menuTelcel',
                        state: {
                            sdkVersion: this.props.sdkVersion,
                            paymentsConfig: config, 
                            isClaroPartner: this.props.isClaroPartner,
                            serviceConfigIndex:2,
                            tagServiceId: this.props.tagServiceId
                        }
                    }}
                >
                    <ContPacks
                        title={"Paquetes Internet Amigo"}
                        serviceId={config.services[2].serviceData.info.categoryPlansId}
                        hasPromotionMbTelcel = {config.services[2].serviceData.info.hasPromotionMbTelcel}
                        textPromotionMbTelcel = {config.services[2].serviceData.info.textPromotionMbTelcel}
                    />
                </Link>
                
                <Link 
                    onClick={() => {
                        this.props.executeTaggeo({
                            action: "Click Amigo Paguitos",
                            service : "Principal Telcel",
                        })
                    }}
                    to={{
                        pathname: '/menuTelcel',
                        state: {
                            sdkVersion: this.props.sdkVersion,
                            paymentsConfig: config, 
                            isClaroPartner: this.props.isClaroPartner,
                            serviceConfigIndex:5,
                            tagServiceId: this.props.tagServiceId
                        }
                    }}
                >
                    <ContPacks
                        title={"Amigo Paguitos"}
                        serviceId={config.services[5].serviceData.info.serviceId}
                        hasPromotionMbTelcel = {config.services[5].serviceData.info.hasPromotionMbTelcel}
                        textPromotionMbTelcel = {config.services[5].serviceData.info.textPromotionMbTelcel}
                    />
                </Link>
                <Link
                    // onClick={() => {
                    //     this.sendAnalytics(
                    //         this.props.tagServiceId,
                    //         'Principal Telcel',
                    //         'Click Paquetes Internet por tiempo'
                    //     )
                    // }}
                    to={{
                        pathname: '/menuTelcel',
                        state: {
                            sdkVersion: this.props.sdkVersion,
                            paymentsConfig: config,
                            isClaroPartner: this.props.isClaroPartner,
                            serviceConfigIndex: 4,
                            tagServiceId: this.props.tagServiceId
                        }
                    }}
                >
                    <ContPacks
                        title={"Paquetes Internet por tiempo"}
                        serviceId={config.services[4].serviceData.info.categoryId}
                        hasPromotionMbTelcel = {config.services[4].serviceData.info.hasPromotionMbTelcel}
                        textPromotionMbTelcel = {config.services[4].serviceData.info.textPromotionMbTelcel}
                    />
                </Link>
                <Link 
                    // onClick={() => {
                    //     this.sendAnalytics(
                    //         this.props.tagServiceId,
                    //         'Principal Telcel',
                    //         'Click Paga tu plan Telcel'
                    //     )
                    // }}
                    to={{
                        pathname: '/menuTelcel',
                        state: {
                            sdkVersion: this.props.sdkVersion,
                            paymentsConfig: config, 
                            isClaroPartner: this.props.isClaroPartner,
                            serviceConfigIndex:1,
                            tagServiceId: this.props.tagServiceId
                        }
                    }}
                >
                    <ContPacks
                        title={"Paga tu plan Telcel"}
                        serviceId={config.services[1].serviceData.info.serviceId}
                        hasPromotionMbTelcel = {config.services[1].serviceData.info.hasPromotionMbTelcel}
                        textPromotionMbTelcel = {config.services[1].serviceData.info.textPromotionMbTelcel}
                    />
                </Link>
            </Container>
        )
    }
}

function mapStateToProps(state) {
  return {
      payments: state.payments
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
        setTrackSteps,
        executeTaggeo
    },
    dispatch,
  );
}

MenuTelcelContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuTelcelContainer);

export default MenuTelcelContainer